const END_OF_LINE = "\r\n";
/**
 * Base class for OrderAudit and BenchmarkAudit (for fixings)
 */
export class CoreAudit {
  public rowId: number;
  public comments: string[];
  public actionTime: number;
  public actionTimeStr: string;
  public userStr: string;
  public orderAction: string;
  public orderStatus: string;

  constructor() {
    // Empty constructor
  }
  public get commentsDisplay(): string {
    return this.comments.join(END_OF_LINE);
  }

  public get maxComments() {
    return this.comments?.length > 1 ? this.comments.length : 1;
  }
}
